// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"gggBQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _edit = require("@react-spectrum/s2/icons/Edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _copy = require("@react-spectrum/s2/icons/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _delete = require("@react-spectrum/s2/icons/Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
"use client";
let rows = [
    {
        id: 1,
        name: 'Charizard',
        type: 'Fire, Flying',
        level: '67'
    },
    {
        id: 2,
        name: 'Blastoise',
        type: 'Water',
        level: '56'
    },
    {
        id: 3,
        name: 'Venusaur',
        type: 'Grass, Poison',
        level: '83'
    },
    {
        id: 4,
        name: 'Pikachu',
        type: 'Electric',
        level: '100'
    }
];
function Example(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.TableView), {
        "aria-label": "Table with action bar",
        selectionMode: "multiple",
        defaultSelectedKeys: [
            2
        ],
        styles: " Za12 FeRsuic12",
        renderActionBar: (selectedKeys)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionBar), {
                ...props,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButton), {
                        onPress: ()=>alert('Edit action'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                children: "Edit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButton), {
                        onPress: ()=>alert('Copy action'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                children: "Copy"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButton), {
                        onPress: ()=>alert('Delete action'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                children: "Delete"
                            })
                        ]
                    })
                ]
            }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.TableHeader), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Column), {
                        isRowHeader: true,
                        children: "Name"
                    }, "name"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Column), {
                        children: "Type"
                    }, "type"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Column), {
                        children: "Level"
                    }, "level")
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TableBody), {
                items: rows,
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Cell), {
                                children: item.name
                            }, "name"),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Cell), {
                                children: item.type
                            }, "type"),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Cell), {
                                children: item.level
                            }, "level")
                        ]
                    })
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"mdx-0:0":"bcSCt","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionBar","gU4lG"],["ActionButton","lNDRs"],["Cell","ioKfY"],["Column","ioKfY"],["Row","ioKfY"],["TableBody","ioKfY"],["TableHeader","ioKfY"],["TableView","ioKfY"],["Text","10r6w"]],"@react-spectrum/s2/icons/Edit":"h4rDR","@react-spectrum/s2/icons/Copy":"6imrL","@react-spectrum/s2/icons/Delete":"elAa6","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bcSCt":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"74WJu":[function(require,module,exports,__globalThis) {
'use strict';
var s;
s = require("8884f512c685da86");
exports.renderToReadableStream = s.renderToReadableStream;
exports.decodeReply = s.decodeReply;
exports.decodeReplyFromAsyncIterable = s.decodeReplyFromAsyncIterable;
exports.decodeAction = s.decodeAction;
exports.decodeFormState = s.decodeFormState;
exports.createClientReference = s.createClientReference;
exports.registerServerReference = s.registerServerReference;
exports.createTemporaryReferenceSet = s.createTemporaryReferenceSet;
exports.registerServerActions = s.registerServerActions;
exports.loadServerAction = s.loadServerAction;

},{"8884f512c685da86":"iGhi4"}],"iGhi4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-server.edge.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactDOM = require("2381f0f3ff03ff95"), React = require("6db66a729b66b575"), ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule$1(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.postpone");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
}, currentView = null, writtenBytes = 0;
function writeChunkAndReturn(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = currentView.length - writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
            currentView.set(chunk, writtenBytes);
            writtenBytes += chunk.byteLength;
        }
    }
    return !0;
}
var textEncoder = new TextEncoder();
function stringToChunk(content) {
    return textEncoder.encode(content);
}
function byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var CLIENT_REFERENCE_TAG$1 = Symbol.for("react.client.reference"), SERVER_REFERENCE_TAG = Symbol.for("react.server.reference"), FunctionBind = Function.prototype.bind, ArraySlice = Array.prototype.slice;
function bind() {
    var newFn = FunctionBind.apply(this, arguments);
    if (this.$$typeof === SERVER_REFERENCE_TAG) {
        var args = ArraySlice.call(arguments, 1), $$typeof = {
            value: SERVER_REFERENCE_TAG
        }, $$id = {
            value: this.$$id
        };
        args = {
            value: this.$$bound ? this.$$bound.concat(args) : args
        };
        return Object.defineProperties(newFn, {
            $$typeof: $$typeof,
            $$id: $$id,
            $$bound: args,
            bind: {
                value: bind,
                configurable: !0
            }
        });
    }
    return newFn;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function prefetchDNS(href) {
    if ("string" === typeof href && href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "D|" + href;
            hints.has(key) || (hints.add(key), emitHint(request, "D", href));
        } else previousDispatcher.D(href);
    }
}
function preconnect(href, crossOrigin) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "C|" + (null == crossOrigin ? "null" : crossOrigin) + "|" + href;
            hints.has(key) || (hints.add(key), "string" === typeof crossOrigin ? emitHint(request, "C", [
                href,
                crossOrigin
            ]) : emitHint(request, "C", href));
        } else previousDispatcher.C(href, crossOrigin);
    }
}
function preload(href, as, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "L";
            if ("image" === as && options) {
                var imageSrcSet = options.imageSrcSet, imageSizes = options.imageSizes, uniquePart = "";
                "string" === typeof imageSrcSet && "" !== imageSrcSet ? (uniquePart += "[" + imageSrcSet + "]", "string" === typeof imageSizes && (uniquePart += "[" + imageSizes + "]")) : uniquePart += "[][]" + href;
                key += "[image]" + uniquePart;
            } else key += "[" + as + "]" + href;
            hints.has(key) || (hints.add(key), (options = trimOptions(options)) ? emitHint(request, "L", [
                href,
                as,
                options
            ]) : emitHint(request, "L", [
                href,
                as
            ]));
        } else previousDispatcher.L(href, as, options);
    }
}
function preloadModule(href, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "m|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "m", [
                href,
                options
            ]) : emitHint(request, "m", href);
        }
        previousDispatcher.m(href, options);
    }
}
function preinitStyle(href, precedence, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "S|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "S", [
                href,
                "string" === typeof precedence ? precedence : 0,
                options
            ]) : "string" === typeof precedence ? emitHint(request, "S", [
                href,
                precedence
            ]) : emitHint(request, "S", href);
        }
        previousDispatcher.S(href, precedence, options);
    }
}
function preinitScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "X|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "X", [
                src,
                options
            ]) : emitHint(request, "X", src);
        }
        previousDispatcher.X(src, options);
    }
}
function preinitModuleScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "M|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "M", [
                src,
                options
            ]) : emitHint(request, "M", src);
        }
        previousDispatcher.M(src, options);
    }
}
function trimOptions(options) {
    if (null == options) return null;
    var hasProperties = !1, trimmed = {}, key;
    for(key in options)null != options[key] && (hasProperties = !0, trimmed[key] = options[key]);
    return hasProperties ? trimmed : null;
}
var supportsRequestStorage = "function" === typeof AsyncLocalStorage, requestStorage = supportsRequestStorage ? new AsyncLocalStorage() : null, TEMPORARY_REFERENCE_TAG = Symbol.for("react.temporary.reference"), proxyHandlers = {
    get: function(target, name) {
        switch(name){
            case "$$typeof":
                return target.$$typeof;
            case "name":
                return;
            case "displayName":
                return;
            case "defaultProps":
                return;
            case "_debugInfo":
                return;
            case "toJSON":
                return;
            case Symbol.toPrimitive:
                return Object.prototype[Symbol.toPrimitive];
            case Symbol.toStringTag:
                return Object.prototype[Symbol.toStringTag];
            case "Provider":
                throw Error("Cannot render a Client Context Provider on the Server. Instead, you can export a Client Component wrapper that itself renders a Client Context Provider.");
        }
        throw Error("Cannot access " + String(name) + " on the server. You cannot dot into a temporary client reference from a server component. You can only pass the value through to the client.");
    },
    set: function() {
        throw Error("Cannot assign to a temporary client reference from a server module.");
    }
};
function createTemporaryReference(temporaryReferences, id) {
    var reference = Object.defineProperties(function() {
        throw Error("Attempted to call a temporary Client Reference from the server but it is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component.");
    }, {
        $$typeof: {
            value: TEMPORARY_REFERENCE_TAG
        }
    });
    reference = new Proxy(reference, proxyHandlers);
    temporaryReferences.set(reference, id);
    return reference;
}
function noop() {}
var SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`.");
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop, noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then(noop, noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var currentRequest$1 = null, thenableIndexCounter = 0, thenableState = null;
function getThenableStateAfterSuspending() {
    var state = thenableState || [];
    thenableState = null;
    return state;
}
var HooksDispatcher = {
    readContext: unsupportedContext,
    use: use,
    useCallback: function(callback) {
        return callback;
    },
    useContext: unsupportedContext,
    useEffect: unsupportedHook,
    useImperativeHandle: unsupportedHook,
    useLayoutEffect: unsupportedHook,
    useInsertionEffect: unsupportedHook,
    useMemo: function(nextCreate) {
        return nextCreate();
    },
    useReducer: unsupportedHook,
    useRef: unsupportedHook,
    useState: unsupportedHook,
    useDebugValue: function() {},
    useDeferredValue: unsupportedHook,
    useTransition: unsupportedHook,
    useSyncExternalStore: unsupportedHook,
    useId: useId,
    useHostTransitionStatus: unsupportedHook,
    useFormState: unsupportedHook,
    useActionState: unsupportedHook,
    useOptimistic: unsupportedHook,
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return unsupportedRefresh;
    }
};
function unsupportedHook() {
    throw Error("This Hook is not supported in Server Components.");
}
function unsupportedRefresh() {
    throw Error("Refreshing the cache is not supported in Server Components.");
}
function unsupportedContext() {
    throw Error("Cannot read a Client Context from a Server Component.");
}
function useId() {
    if (null === currentRequest$1) throw Error("useId can only be used while React is rendering");
    var id = currentRequest$1.identifierCount++;
    return "_" + currentRequest$1.identifierPrefix + "S_" + id.toString(32) + "_";
}
function use(usable) {
    if (null !== usable && "object" === typeof usable || "function" === typeof usable) {
        if ("function" === typeof usable.then) {
            var index = thenableIndexCounter;
            thenableIndexCounter += 1;
            null === thenableState && (thenableState = []);
            return trackUsedThenable(thenableState, usable, index);
        }
        usable.$$typeof === REACT_CONTEXT_TYPE && unsupportedContext();
    }
    if (usable.$$typeof === CLIENT_REFERENCE_TAG$1) {
        if (null != usable.value && usable.value.$$typeof === REACT_CONTEXT_TYPE) throw Error("Cannot read a Client Context from a Server Component.");
        throw Error("Cannot use() an already resolved Client Reference.");
    }
    throw Error("An unsupported type was passed to use(): " + String(usable));
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var JSCompiler_inline_result = (JSCompiler_inline_result = resolveRequest()) ? JSCompiler_inline_result.cache : new Map();
        var entry = JSCompiler_inline_result.get(resourceType);
        void 0 === entry && (entry = resourceType(), JSCompiler_inline_result.set(resourceType, entry));
        return entry;
    },
    cacheSignal: function() {
        var request = resolveRequest();
        return request ? request.cacheController.signal : null;
    }
}, ReactSharedInternalsServer = React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
if (!ReactSharedInternalsServer) throw Error('The "react" package in this environment is not configured correctly. The "react-server" condition must be enabled in any environment that runs React Server Components.');
var isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf;
function objectName(object) {
    object = Object.prototype.toString.call(object);
    return object.slice(8, object.length - 1);
}
function describeValueForErrorMessage(value) {
    switch(typeof value){
        case "string":
            return JSON.stringify(10 >= value.length ? value : value.slice(0, 10) + "...");
        case "object":
            if (isArrayImpl(value)) return "[...]";
            if (null !== value && value.$$typeof === CLIENT_REFERENCE_TAG) return "client";
            value = objectName(value);
            return "Object" === value ? "{...}" : value;
        case "function":
            return value.$$typeof === CLIENT_REFERENCE_TAG ? "client" : (value = value.displayName || value.name) ? "function " + value : "function";
        default:
            return String(value);
    }
}
function describeElementType(type) {
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_FORWARD_REF_TYPE:
            return describeElementType(type.render);
        case REACT_MEMO_TYPE:
            return describeElementType(type.type);
        case REACT_LAZY_TYPE:
            var payload = type._payload;
            type = type._init;
            try {
                return describeElementType(type(payload));
            } catch (x) {}
    }
    return "";
}
var CLIENT_REFERENCE_TAG = Symbol.for("react.client.reference");
function describeObjectForErrorMessage(objectOrArray, expandedName) {
    var objKind = objectName(objectOrArray);
    if ("Object" !== objKind && "Array" !== objKind) return objKind;
    objKind = -1;
    var length = 0;
    if (isArrayImpl(objectOrArray)) {
        var str = "[";
        for(var i = 0; i < objectOrArray.length; i++){
            0 < i && (str += ", ");
            var value = objectOrArray[i];
            value = "object" === typeof value && null !== value ? describeObjectForErrorMessage(value) : describeValueForErrorMessage(value);
            "" + i === expandedName ? (objKind = str.length, length = value.length, str += value) : str = 10 > value.length && 40 > str.length + value.length ? str + value : str + "...";
        }
        str += "]";
    } else if (objectOrArray.$$typeof === REACT_ELEMENT_TYPE) str = "<" + describeElementType(objectOrArray.type) + "/>";
    else {
        if (objectOrArray.$$typeof === CLIENT_REFERENCE_TAG) return "client";
        str = "{";
        i = Object.keys(objectOrArray);
        for(value = 0; value < i.length; value++){
            0 < value && (str += ", ");
            var name = i[value], encodedKey = JSON.stringify(name);
            str += ('"' + name + '"' === encodedKey ? name : encodedKey) + ": ";
            encodedKey = objectOrArray[name];
            encodedKey = "object" === typeof encodedKey && null !== encodedKey ? describeObjectForErrorMessage(encodedKey) : describeValueForErrorMessage(encodedKey);
            name === expandedName ? (objKind = str.length, length = encodedKey.length, str += encodedKey) : str = 10 > encodedKey.length && 40 > str.length + encodedKey.length ? str + encodedKey : str + "...";
        }
        str += "}";
    }
    return void 0 === expandedName ? str : -1 < objKind && 0 < length ? (objectOrArray = " ".repeat(objKind) + "^".repeat(length), "\n  " + str + "\n  " + objectOrArray) : "\n  " + str;
}
var hasOwnProperty = Object.prototype.hasOwnProperty, ObjectPrototype = Object.prototype, stringify = JSON.stringify;
function defaultErrorHandler(error) {
    console.error(error);
}
function RequestInstance(type, model, bundlerConfig, onError, onPostpone, onAllReady, onFatalError, identifierPrefix, temporaryReferences) {
    if (null !== ReactSharedInternalsServer.A && ReactSharedInternalsServer.A !== DefaultAsyncDispatcher) throw Error("Currently React only supports one RSC renderer at a time.");
    ReactSharedInternalsServer.A = DefaultAsyncDispatcher;
    var abortSet = new Set(), pingedTasks = [], hints = new Set();
    this.type = type;
    this.status = 10;
    this.flushScheduled = !1;
    this.destination = this.fatalError = null;
    this.bundlerConfig = bundlerConfig;
    this.cache = new Map();
    this.cacheController = new AbortController();
    this.pendingChunks = this.nextChunkId = 0;
    this.hints = hints;
    this.abortableTasks = abortSet;
    this.pingedTasks = pingedTasks;
    this.completedImportChunks = [];
    this.completedHintChunks = [];
    this.completedRegularChunks = [];
    this.completedErrorChunks = [];
    this.writtenSymbols = new Map();
    this.writtenClientReferences = new Map();
    this.writtenServerReferences = new Map();
    this.writtenObjects = new WeakMap();
    this.temporaryReferences = temporaryReferences;
    this.identifierPrefix = identifierPrefix || "";
    this.identifierCount = 1;
    this.taintCleanupQueue = [];
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = onAllReady;
    this.onFatalError = onFatalError;
    type = createTask(this, model, null, !1, abortSet);
    pingedTasks.push(type);
}
var currentRequest = null;
function resolveRequest() {
    if (currentRequest) return currentRequest;
    if (supportsRequestStorage) {
        var store = requestStorage.getStore();
        if (store) return store;
    }
    return null;
}
function serializeThenable(request, task, thenable) {
    var newTask = createTask(request, thenable, task.keyPath, task.implicitSlot, request.abortableTasks);
    switch(thenable.status){
        case "fulfilled":
            return newTask.model = thenable.value, pingTask(request, newTask), newTask.id;
        case "rejected":
            return erroredTask(request, newTask, thenable.reason), newTask.id;
        default:
            if (12 === request.status) return request.abortableTasks.delete(newTask), task = request.fatalError, abortTask(newTask), finishAbortedTask(newTask, request, task), newTask.id;
            "string" !== typeof thenable.status && (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            }));
    }
    thenable.then(function(value) {
        newTask.model = value;
        pingTask(request, newTask);
    }, function(reason) {
        0 === newTask.status && (erroredTask(request, newTask, reason), enqueueFlush(request));
    });
    return newTask.id;
}
function serializeReadableStream(request, task, stream) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) streamTask.status = 1, entry = streamTask.id.toString(16) + ":C\n", request.completedRegularChunks.push(stringToChunk(entry)), request.abortableTasks.delete(streamTask), request.cacheController.signal.removeEventListener("abort", abortStream), enqueueFlush(request), callOnAllReadyIfReady(request);
            else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), reader.read().then(progress, error);
            } catch (x$8) {
                error(x$8);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortStream), erroredTask(request, streamTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortStream() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortStream);
            signal = signal.reason;
            erroredTask(request, streamTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var supportsBYOB = stream.supportsBYOB;
    if (void 0 === supportsBYOB) try {
        stream.getReader({
            mode: "byob"
        }).releaseLock(), supportsBYOB = !0;
    } catch (x) {
        supportsBYOB = !1;
    }
    var reader = stream.getReader(), streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (supportsBYOB ? "r" : "R") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortStream);
    reader.read().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function serializeAsyncIterable(request, task, iterable, iterator) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) {
                streamTask.status = 1;
                if (void 0 === entry.value) var endStreamRow = streamTask.id.toString(16) + ":C\n";
                else try {
                    var chunkId = outlineModel(request, entry.value);
                    endStreamRow = streamTask.id.toString(16) + ":C" + stringify(serializeByValueID(chunkId)) + "\n";
                } catch (x) {
                    error(x);
                    return;
                }
                request.completedRegularChunks.push(stringToChunk(endStreamRow));
                request.abortableTasks.delete(streamTask);
                request.cacheController.signal.removeEventListener("abort", abortIterable);
                enqueueFlush(request);
                callOnAllReadyIfReady(request);
            } else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), iterator.next().then(progress, error);
            } catch (x$9) {
                error(x$9);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortIterable), erroredTask(request, streamTask, reason), enqueueFlush(request), "function" === typeof iterator.throw && iterator.throw(reason).then(error, error));
    }
    function abortIterable() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortIterable);
            var reason = signal.reason;
            erroredTask(request, streamTask, signal.reason);
            enqueueFlush(request);
            "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
        }
    }
    iterable = iterable === iterator;
    var streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (iterable ? "x" : "X") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortIterable);
    iterator.next().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function emitHint(request, code, model) {
    model = stringify(model);
    code = stringToChunk(":H" + code + model + "\n");
    request.completedHintChunks.push(code);
    enqueueFlush(request);
}
function readThenable(thenable) {
    if ("fulfilled" === thenable.status) return thenable.value;
    if ("rejected" === thenable.status) throw thenable.reason;
    throw thenable;
}
function createLazyWrapperAroundWakeable(request, task, wakeable) {
    switch(wakeable.status){
        case "fulfilled":
            return wakeable.value;
        case "rejected":
            break;
        default:
            "string" !== typeof wakeable.status && (wakeable.status = "pending", wakeable.then(function(fulfilledValue) {
                "pending" === wakeable.status && (wakeable.status = "fulfilled", wakeable.value = fulfilledValue);
            }, function(error) {
                "pending" === wakeable.status && (wakeable.status = "rejected", wakeable.reason = error);
            }));
    }
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: wakeable,
        _init: readThenable
    };
}
function voidHandler() {}
function processServerComponentReturnValue(request, task, Component, result) {
    if ("object" !== typeof result || null === result || result.$$typeof === CLIENT_REFERENCE_TAG$1) return result;
    if ("function" === typeof result.then) return createLazyWrapperAroundWakeable(request, task, result);
    var iteratorFn = getIteratorFn(result);
    return iteratorFn ? (request = {}, request[Symbol.iterator] = function() {
        return iteratorFn.call(result);
    }, request) : "function" !== typeof result[ASYNC_ITERATOR] || "function" === typeof ReadableStream && result instanceof ReadableStream ? result : (request = {}, request[ASYNC_ITERATOR] = function() {
        return result[ASYNC_ITERATOR]();
    }, request);
}
function renderFunctionComponent(request, task, key, Component, props) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    props = Component(props, void 0);
    if (12 === request.status) throw "object" === typeof props && null !== props && "function" === typeof props.then && props.$$typeof !== CLIENT_REFERENCE_TAG$1 && props.then(voidHandler, voidHandler), null;
    props = processServerComponentReturnValue(request, task, Component, props);
    Component = task.keyPath;
    prevThenableState = task.implicitSlot;
    null !== key ? task.keyPath = null === Component ? key : Component + "," + key : null === Component && (task.implicitSlot = !0);
    request = renderModelDestructive(request, task, emptyRoot, "", props);
    task.keyPath = Component;
    task.implicitSlot = prevThenableState;
    return request;
}
function renderFragment(request, task, children) {
    return null !== task.keyPath ? (request = [
        REACT_ELEMENT_TYPE,
        REACT_FRAGMENT_TYPE,
        task.keyPath,
        {
            children: children
        }
    ], task.implicitSlot ? [
        request
    ] : request) : children;
}
var serializedSize = 0;
function deferTask(request, task) {
    task = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    pingTask(request, task);
    return "$L" + task.id.toString(16);
}
function renderElement(request, task, type, key, ref, props) {
    if (null !== ref && void 0 !== ref) throw Error("Refs cannot be used in Server Components, nor passed to Client Components.");
    if ("function" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1 && type.$$typeof !== TEMPORARY_REFERENCE_TAG) return renderFunctionComponent(request, task, key, type, props);
    if (type === REACT_FRAGMENT_TYPE && null === key) return type = task.implicitSlot, null === task.keyPath && (task.implicitSlot = !0), props = renderModelDestructive(request, task, emptyRoot, "", props.children), task.implicitSlot = type, props;
    if (null != type && "object" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1) switch(type.$$typeof){
        case REACT_LAZY_TYPE:
            var init = type._init;
            type = init(type._payload);
            if (12 === request.status) throw null;
            return renderElement(request, task, type, key, ref, props);
        case REACT_FORWARD_REF_TYPE:
            return renderFunctionComponent(request, task, key, type.render, props);
        case REACT_MEMO_TYPE:
            return renderElement(request, task, type.type, key, ref, props);
    }
    request = key;
    key = task.keyPath;
    null === request ? request = key : null !== key && (request = key + "," + request);
    props = [
        REACT_ELEMENT_TYPE,
        type,
        request,
        props
    ];
    task = task.implicitSlot && null !== request ? [
        props
    ] : props;
    return task;
}
function pingTask(request, task) {
    var pingedTasks = request.pingedTasks;
    pingedTasks.push(task);
    1 === pingedTasks.length && (request.flushScheduled = null !== request.destination, 21 === request.type || 10 === request.status ? scheduleMicrotask(function() {
        return performWork(request);
    }) : setTimeout(function() {
        return performWork(request);
    }, 0));
}
function createTask(request, model, keyPath, implicitSlot, abortSet) {
    request.pendingChunks++;
    var id = request.nextChunkId++;
    "object" !== typeof model || null === model || null !== keyPath || implicitSlot || request.writtenObjects.set(model, serializeByValueID(id));
    var task = {
        id: id,
        status: 0,
        model: model,
        keyPath: keyPath,
        implicitSlot: implicitSlot,
        ping: function() {
            return pingTask(request, task);
        },
        toJSON: function(parentPropertyName, value) {
            serializedSize += parentPropertyName.length;
            var prevKeyPath = task.keyPath, prevImplicitSlot = task.implicitSlot;
            try {
                var JSCompiler_inline_result = renderModelDestructive(request, task, this, parentPropertyName, value);
            } catch (thrownValue) {
                if (parentPropertyName = task.model, parentPropertyName = "object" === typeof parentPropertyName && null !== parentPropertyName && (parentPropertyName.$$typeof === REACT_ELEMENT_TYPE || parentPropertyName.$$typeof === REACT_LAZY_TYPE), 12 === request.status) task.status = 3, prevKeyPath = request.fatalError, JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
                else if (value = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof value && null !== value && "function" === typeof value.then) {
                    JSCompiler_inline_result = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
                    var ping = JSCompiler_inline_result.ping;
                    value.then(ping, ping);
                    JSCompiler_inline_result.thenableState = getThenableStateAfterSuspending();
                    task.keyPath = prevKeyPath;
                    task.implicitSlot = prevImplicitSlot;
                    JSCompiler_inline_result = parentPropertyName ? "$L" + JSCompiler_inline_result.id.toString(16) : serializeByValueID(JSCompiler_inline_result.id);
                } else task.keyPath = prevKeyPath, task.implicitSlot = prevImplicitSlot, request.pendingChunks++, prevKeyPath = request.nextChunkId++, prevImplicitSlot = logRecoverableError(request, value, task), emitErrorChunk(request, prevKeyPath, prevImplicitSlot), JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
            }
            return JSCompiler_inline_result;
        },
        thenableState: null
    };
    abortSet.add(task);
    return task;
}
function serializeByValueID(id) {
    return "$" + id.toString(16);
}
function encodeReferenceChunk(request, id, reference) {
    request = stringify(reference);
    id = id.toString(16) + ":" + request + "\n";
    return stringToChunk(id);
}
function serializeClientReference(request, parent, parentPropertyName, clientReference) {
    var clientReferenceKey = clientReference.$$id + "#" + clientReference.$$name, writtenClientReferences = request.writtenClientReferences, existingId = writtenClientReferences.get(clientReferenceKey);
    if (void 0 !== existingId) return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + existingId.toString(16) : serializeByValueID(existingId);
    try {
        var JSCompiler_inline_result = clientReference.$$importMap ? [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles,
            clientReference.$$importMap
        ] : [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles
        ];
        request.pendingChunks++;
        var importId = request.nextChunkId++, json = stringify(JSCompiler_inline_result), row = importId.toString(16) + ":I" + json + "\n", processedChunk = stringToChunk(row);
        request.completedImportChunks.push(processedChunk);
        writtenClientReferences.set(clientReferenceKey, importId);
        return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + importId.toString(16) : serializeByValueID(importId);
    } catch (x) {
        return request.pendingChunks++, parent = request.nextChunkId++, parentPropertyName = logRecoverableError(request, x, null), emitErrorChunk(request, parent, parentPropertyName), serializeByValueID(parent);
    }
}
function outlineModel(request, value) {
    value = createTask(request, value, null, !1, request.abortableTasks);
    retryTask(request, value);
    return value.id;
}
function serializeTypedArray(request, tag, typedArray) {
    request.pendingChunks++;
    var bufferId = request.nextChunkId++;
    emitTypedArrayChunk(request, bufferId, tag, typedArray, !1);
    return serializeByValueID(bufferId);
}
function serializeBlob(request, blob) {
    function progress(entry) {
        if (0 === newTask.status) {
            if (entry.done) request.cacheController.signal.removeEventListener("abort", abortBlob), pingTask(request, newTask);
            else return model.push(entry.value), reader.read().then(progress).catch(error);
        }
    }
    function error(reason) {
        0 === newTask.status && (request.cacheController.signal.removeEventListener("abort", abortBlob), erroredTask(request, newTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortBlob() {
        if (0 === newTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortBlob);
            signal = signal.reason;
            erroredTask(request, newTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var model = [
        blob.type
    ], newTask = createTask(request, model, null, !1, request.abortableTasks), reader = blob.stream().getReader();
    request.cacheController.signal.addEventListener("abort", abortBlob);
    reader.read().then(progress).catch(error);
    return "$B" + newTask.id.toString(16);
}
var modelRoot = !1;
function renderModelDestructive(request, task, parent, parentPropertyName, value) {
    task.model = value;
    if (value === REACT_ELEMENT_TYPE) return "$";
    if (null === value) return null;
    if ("object" === typeof value) {
        switch(value.$$typeof){
            case REACT_ELEMENT_TYPE:
                var elementReference = null, writtenObjects = request.writtenObjects;
                if (null === task.keyPath && !task.implicitSlot) {
                    var existingReference = writtenObjects.get(value);
                    if (void 0 !== existingReference) {
                        if (modelRoot === value) modelRoot = null;
                        else return existingReference;
                    } else -1 === parentPropertyName.indexOf(":") && (parent = writtenObjects.get(parent), void 0 !== parent && (elementReference = parent + ":" + parentPropertyName, writtenObjects.set(value, elementReference)));
                }
                if (3200 < serializedSize) return deferTask(request, task);
                parentPropertyName = value.props;
                parent = parentPropertyName.ref;
                request = renderElement(request, task, value.type, value.key, void 0 !== parent ? parent : null, parentPropertyName);
                "object" === typeof request && null !== request && null !== elementReference && (writtenObjects.has(request) || writtenObjects.set(request, elementReference));
                return request;
            case REACT_LAZY_TYPE:
                if (3200 < serializedSize) return deferTask(request, task);
                task.thenableState = null;
                parentPropertyName = value._init;
                value = parentPropertyName(value._payload);
                if (12 === request.status) throw null;
                return renderModelDestructive(request, task, emptyRoot, "", value);
            case REACT_LEGACY_ELEMENT_TYPE:
                throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        }
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (void 0 !== request.temporaryReferences && (elementReference = request.temporaryReferences.get(value), void 0 !== elementReference)) return "$T" + elementReference;
        elementReference = request.writtenObjects;
        writtenObjects = elementReference.get(value);
        if ("function" === typeof value.then) {
            if (void 0 !== writtenObjects) {
                if (null !== task.keyPath || task.implicitSlot) return "$@" + serializeThenable(request, task, value).toString(16);
                if (modelRoot === value) modelRoot = null;
                else return writtenObjects;
            }
            request = "$@" + serializeThenable(request, task, value).toString(16);
            elementReference.set(value, request);
            return request;
        }
        if (void 0 !== writtenObjects) {
            if (modelRoot === value) {
                if (writtenObjects !== serializeByValueID(task.id)) return writtenObjects;
                modelRoot = null;
            } else return writtenObjects;
        } else if (-1 === parentPropertyName.indexOf(":") && (writtenObjects = elementReference.get(parent), void 0 !== writtenObjects)) {
            existingReference = parentPropertyName;
            if (isArrayImpl(parent) && parent[0] === REACT_ELEMENT_TYPE) switch(parentPropertyName){
                case "1":
                    existingReference = "type";
                    break;
                case "2":
                    existingReference = "key";
                    break;
                case "3":
                    existingReference = "props";
                    break;
                case "4":
                    existingReference = "_owner";
            }
            elementReference.set(value, writtenObjects + ":" + existingReference);
        }
        if (isArrayImpl(value)) return renderFragment(request, task, value);
        if (value instanceof Map) return value = Array.from(value), "$Q" + outlineModel(request, value).toString(16);
        if (value instanceof Set) return value = Array.from(value), "$W" + outlineModel(request, value).toString(16);
        if ("function" === typeof FormData && value instanceof FormData) return value = Array.from(value.entries()), "$K" + outlineModel(request, value).toString(16);
        if (value instanceof Error) return "$Z";
        if (value instanceof ArrayBuffer) return serializeTypedArray(request, "A", new Uint8Array(value));
        if (value instanceof Int8Array) return serializeTypedArray(request, "O", value);
        if (value instanceof Uint8Array) return serializeTypedArray(request, "o", value);
        if (value instanceof Uint8ClampedArray) return serializeTypedArray(request, "U", value);
        if (value instanceof Int16Array) return serializeTypedArray(request, "S", value);
        if (value instanceof Uint16Array) return serializeTypedArray(request, "s", value);
        if (value instanceof Int32Array) return serializeTypedArray(request, "L", value);
        if (value instanceof Uint32Array) return serializeTypedArray(request, "l", value);
        if (value instanceof Float32Array) return serializeTypedArray(request, "G", value);
        if (value instanceof Float64Array) return serializeTypedArray(request, "g", value);
        if (value instanceof BigInt64Array) return serializeTypedArray(request, "M", value);
        if (value instanceof BigUint64Array) return serializeTypedArray(request, "m", value);
        if (value instanceof DataView) return serializeTypedArray(request, "V", value);
        if ("function" === typeof Blob && value instanceof Blob) return serializeBlob(request, value);
        if (elementReference = getIteratorFn(value)) return parentPropertyName = elementReference.call(value), parentPropertyName === value ? "$i" + outlineModel(request, Array.from(parentPropertyName)).toString(16) : renderFragment(request, task, Array.from(parentPropertyName));
        if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(request, task, value);
        elementReference = value[ASYNC_ITERATOR];
        if ("function" === typeof elementReference) return null !== task.keyPath ? (request = [
            REACT_ELEMENT_TYPE,
            REACT_FRAGMENT_TYPE,
            task.keyPath,
            {
                children: value
            }
        ], request = task.implicitSlot ? [
            request
        ] : request) : (parentPropertyName = elementReference.call(value), request = serializeAsyncIterable(request, task, value, parentPropertyName)), request;
        if (value instanceof Date) return "$D" + value.toJSON();
        request = getPrototypeOf(value);
        if (request !== ObjectPrototype && (null === request || null !== getPrototypeOf(request))) throw Error("Only plain objects, and a few built-ins, can be passed to Client Components from Server Components. Classes or null prototypes are not supported." + describeObjectForErrorMessage(parent, parentPropertyName));
        return value;
    }
    if ("string" === typeof value) {
        serializedSize += value.length;
        if ("Z" === value[value.length - 1] && parent[parentPropertyName] instanceof Date) return "$D" + value;
        if (1024 <= value.length && null !== byteLengthOfChunk) return request.pendingChunks++, task = request.nextChunkId++, emitTextChunk(request, task, value, !1), serializeByValueID(task);
        request = "$" === value[0] ? "$" + value : value;
        return request;
    }
    if ("boolean" === typeof value) return value;
    if ("number" === typeof value) return Number.isFinite(value) ? 0 === value && -Infinity === 1 / value ? "$-0" : value : Infinity === value ? "$Infinity" : -Infinity === value ? "$-Infinity" : "$NaN";
    if ("undefined" === typeof value) return "$undefined";
    if ("function" === typeof value) {
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (value.$$typeof === SERVER_REFERENCE_TAG) return task = request.writtenServerReferences, parentPropertyName = task.get(value), void 0 !== parentPropertyName ? request = "$F" + parentPropertyName.toString(16) : (parentPropertyName = value.$$bound, parentPropertyName = null === parentPropertyName ? null : Promise.resolve(parentPropertyName), request = outlineModel(request, {
            id: value.$$id,
            bound: parentPropertyName
        }), task.set(value, request), request = "$F" + request.toString(16)), request;
        if (void 0 !== request.temporaryReferences && (request = request.temporaryReferences.get(value), void 0 !== request)) return "$T" + request;
        if (value.$$typeof === TEMPORARY_REFERENCE_TAG) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
        if (/^on[A-Z]/.test(parentPropertyName)) throw Error("Event handlers cannot be passed to Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName) + "\nIf you need interactivity, consider converting part of this to a Client Component.");
        throw Error('Functions cannot be passed directly to Client Components unless you explicitly expose it by marking it with "use server". Or maybe you meant to call this function rather than return it.' + describeObjectForErrorMessage(parent, parentPropertyName));
    }
    if ("symbol" === typeof value) {
        task = request.writtenSymbols;
        elementReference = task.get(value);
        if (void 0 !== elementReference) return serializeByValueID(elementReference);
        elementReference = value.description;
        if (Symbol.for(elementReference) !== value) throw Error("Only global symbols received from Symbol.for(...) can be passed to Client Components. The symbol Symbol.for(" + (value.description + ") cannot be found among global symbols.") + describeObjectForErrorMessage(parent, parentPropertyName));
        request.pendingChunks++;
        parentPropertyName = request.nextChunkId++;
        parent = encodeReferenceChunk(request, parentPropertyName, "$S" + elementReference);
        request.completedImportChunks.push(parent);
        task.set(value, parentPropertyName);
        return serializeByValueID(parentPropertyName);
    }
    if ("bigint" === typeof value) return "$n" + value.toString(10);
    throw Error("Type " + typeof value + " is not supported in Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName));
}
function logRecoverableError(request, error) {
    var prevRequest = currentRequest;
    currentRequest = null;
    try {
        var onError = request.onError;
        var errorDigest = supportsRequestStorage ? requestStorage.run(void 0, onError, error) : onError(error);
    } finally{
        currentRequest = prevRequest;
    }
    if (null != errorDigest && "string" !== typeof errorDigest) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
    return errorDigest || "";
}
function fatalError(request, error) {
    var onFatalError = request.onFatalError;
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
    request.cacheController.abort(Error("The render was aborted due to a fatal error.", {
        cause: error
    }));
}
function emitErrorChunk(request, id, digest) {
    digest = {
        digest: digest
    };
    id = id.toString(16) + ":E" + stringify(digest) + "\n";
    id = stringToChunk(id);
    request.completedErrorChunks.push(id);
}
function emitModelChunk(request, id, json) {
    id = id.toString(16) + ":" + json + "\n";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id);
}
function emitTypedArrayChunk(request, id, tag, typedArray, debug) {
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    debug = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    typedArray = 2048 < typedArray.byteLength ? debug.slice() : debug;
    debug = typedArray.byteLength;
    id = id.toString(16) + ":" + tag + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, typedArray);
}
function emitTextChunk(request, id, text, debug) {
    if (null === byteLengthOfChunk) throw Error("Existence of byteLengthOfChunk should have already been checked. This is a bug in React.");
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    text = stringToChunk(text);
    debug = text.byteLength;
    id = id.toString(16) + ":T" + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, text);
}
function emitChunk(request, task, value) {
    var id = task.id;
    "string" === typeof value && null !== byteLengthOfChunk ? emitTextChunk(request, id, value, !1) : value instanceof ArrayBuffer ? emitTypedArrayChunk(request, id, "A", new Uint8Array(value), !1) : value instanceof Int8Array ? emitTypedArrayChunk(request, id, "O", value, !1) : value instanceof Uint8Array ? emitTypedArrayChunk(request, id, "o", value, !1) : value instanceof Uint8ClampedArray ? emitTypedArrayChunk(request, id, "U", value, !1) : value instanceof Int16Array ? emitTypedArrayChunk(request, id, "S", value, !1) : value instanceof Uint16Array ? emitTypedArrayChunk(request, id, "s", value, !1) : value instanceof Int32Array ? emitTypedArrayChunk(request, id, "L", value, !1) : value instanceof Uint32Array ? emitTypedArrayChunk(request, id, "l", value, !1) : value instanceof Float32Array ? emitTypedArrayChunk(request, id, "G", value, !1) : value instanceof Float64Array ? emitTypedArrayChunk(request, id, "g", value, !1) : value instanceof BigInt64Array ? emitTypedArrayChunk(request, id, "M", value, !1) : value instanceof BigUint64Array ? emitTypedArrayChunk(request, id, "m", value, !1) : value instanceof DataView ? emitTypedArrayChunk(request, id, "V", value, !1) : (value = stringify(value, task.toJSON), emitModelChunk(request, task.id, value));
}
function erroredTask(request, task, error) {
    task.status = 4;
    error = logRecoverableError(request, error, task);
    emitErrorChunk(request, task.id, error);
    request.abortableTasks.delete(task);
    callOnAllReadyIfReady(request);
}
var emptyRoot = {};
function retryTask(request, task) {
    if (0 === task.status) {
        task.status = 5;
        var parentSerializedSize = serializedSize;
        try {
            modelRoot = task.model;
            var resolvedModel = renderModelDestructive(request, task, emptyRoot, "", task.model);
            modelRoot = resolvedModel;
            task.keyPath = null;
            task.implicitSlot = !1;
            if ("object" === typeof resolvedModel && null !== resolvedModel) request.writtenObjects.set(resolvedModel, serializeByValueID(task.id)), emitChunk(request, task, resolvedModel);
            else {
                var json = stringify(resolvedModel);
                emitModelChunk(request, task.id, json);
            }
            task.status = 1;
            request.abortableTasks.delete(task);
            callOnAllReadyIfReady(request);
        } catch (thrownValue) {
            if (12 === request.status) {
                request.abortableTasks.delete(task);
                task.status = 0;
                var errorId = request.fatalError;
                abortTask(task);
                finishAbortedTask(task, request, errorId);
            } else {
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                    task.status = 0;
                    task.thenableState = getThenableStateAfterSuspending();
                    var ping = task.ping;
                    x.then(ping, ping);
                } else erroredTask(request, task, x);
            }
        } finally{
            serializedSize = parentSerializedSize;
        }
    }
}
function tryStreamTask(request, task) {
    var parentSerializedSize = serializedSize;
    try {
        emitChunk(request, task, task.model);
    } finally{
        serializedSize = parentSerializedSize;
    }
}
function performWork(request) {
    var prevDispatcher = ReactSharedInternalsServer.H;
    ReactSharedInternalsServer.H = HooksDispatcher;
    var prevRequest = currentRequest;
    currentRequest$1 = currentRequest = request;
    try {
        var pingedTasks = request.pingedTasks;
        request.pingedTasks = [];
        for(var i = 0; i < pingedTasks.length; i++)retryTask(request, pingedTasks[i]);
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    } finally{
        ReactSharedInternalsServer.H = prevDispatcher, currentRequest$1 = null, currentRequest = prevRequest;
    }
}
function abortTask(task) {
    0 === task.status && (task.status = 3);
}
function finishAbortedTask(task, request, errorId) {
    3 === task.status && (errorId = serializeByValueID(errorId), task = encodeReferenceChunk(request, task.id, errorId), request.completedErrorChunks.push(task));
}
function flushCompletedChunks(request) {
    var destination = request.destination;
    if (null !== destination) {
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        try {
            for(var importsChunks = request.completedImportChunks, i = 0; i < importsChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, importsChunks[i]);
            importsChunks.splice(0, i);
            var hintChunks = request.completedHintChunks;
            for(i = 0; i < hintChunks.length; i++)writeChunkAndReturn(destination, hintChunks[i]);
            hintChunks.splice(0, i);
            var regularChunks = request.completedRegularChunks;
            for(i = 0; i < regularChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, regularChunks[i]);
            regularChunks.splice(0, i);
            var errorChunks = request.completedErrorChunks;
            for(i = 0; i < errorChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, errorChunks[i]);
            errorChunks.splice(0, i);
        } finally{
            request.flushScheduled = !1, currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
        }
    }
    0 === request.pendingChunks && (12 > request.status && request.cacheController.abort(Error("This render completed successfully. All cacheSignals are now aborted to allow clean up of any unused resources.")), null !== request.destination && (request.status = 14, request.destination.close(), request.destination = null));
}
function startWork(request) {
    request.flushScheduled = null !== request.destination;
    supportsRequestStorage ? scheduleMicrotask(function() {
        requestStorage.run(request, performWork, request);
    }) : scheduleMicrotask(function() {
        return performWork(request);
    });
    setTimeout(function() {
        10 === request.status && (request.status = 11);
    }, 0);
}
function enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, setTimeout(function() {
        request.flushScheduled = !1;
        flushCompletedChunks(request);
    }, 0));
}
function callOnAllReadyIfReady(request) {
    0 === request.abortableTasks.size && (request = request.onAllReady, request());
}
function startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            flushCompletedChunks(request);
        } catch (error) {
            logRecoverableError(request, error, null), fatalError(request, error);
        }
    }
}
function finishAbort(request, abortedTasks, errorId) {
    try {
        abortedTasks.forEach(function(task) {
            return finishAbortedTask(task, request, errorId);
        });
        var onAllReady = request.onAllReady;
        onAllReady();
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    }
}
function abort(request, reason) {
    if (!(11 < request.status)) try {
        request.status = 12;
        request.cacheController.abort(reason);
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error("The render was aborted by the server without a reason.") : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error("The render was aborted by the server with a promise.") : reason, digest = logRecoverableError(request, error, null), errorId = request.nextChunkId++;
            request.fatalError = errorId;
            request.pendingChunks++;
            emitErrorChunk(request, errorId, digest, error, !1);
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, errorId);
            });
            setTimeout(function() {
                return finishAbort(request, abortableTasks, errorId);
            }, 0);
        } else {
            var onAllReady = request.onAllReady;
            onAllReady();
            flushCompletedChunks(request);
        }
    } catch (error$23) {
        logRecoverableError(request, error$23, null), fatalError(request, error$23);
    }
}
function Chunk(status, value, reason, response) {
    this.status = status;
    this.value = value;
    this.reason = reason;
    this._response = response;
}
Chunk.prototype = Object.create(Promise.prototype);
Chunk.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            resolve(this.value);
            break;
        case "pending":
        case "blocked":
        case "cyclic":
            resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        default:
            reject(this.reason);
    }
};
function createPendingChunk(response) {
    return new Chunk("pending", null, null, response);
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++)(0, listeners[i])(value);
}
function triggerErrorOnChunk(chunk, error) {
    if ("pending" !== chunk.status && "blocked" !== chunk.status) chunk.reason.error(error);
    else {
        var listeners = chunk.reason;
        chunk.status = "rejected";
        chunk.reason = error;
        null !== listeners && wakeChunk(listeners, error);
    }
}
function resolveModelChunk(chunk, value, id) {
    if ("pending" !== chunk.status) chunk = chunk.reason, "C" === value[0] ? chunk.close("C" === value ? '"$undefined"' : value.slice(1)) : chunk.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = id;
        if (null !== resolveListeners) switch(initializeModelChunk(chunk), chunk.status){
            case "fulfilled":
                wakeChunk(resolveListeners, chunk.value);
                break;
            case "pending":
            case "blocked":
            case "cyclic":
                if (chunk.value) for(value = 0; value < resolveListeners.length; value++)chunk.value.push(resolveListeners[value]);
                else chunk.value = resolveListeners;
                if (chunk.reason) {
                    if (rejectListeners) for(value = 0; value < rejectListeners.length; value++)chunk.reason.push(rejectListeners[value]);
                } else chunk.reason = rejectListeners;
                break;
            case "rejected":
                rejectListeners && wakeChunk(rejectListeners, chunk.reason);
        }
    }
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new Chunk("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1, response);
}
function resolveIteratorResultChunk(chunk, value, done) {
    resolveModelChunk(chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1);
}
function loadServerReference$1(response, id, bound, parentChunk, parentObject, key) {
    var serverReference = resolveServerReference(response._bundlerConfig, id);
    id = preloadModule$1(serverReference);
    if (bound) bound = Promise.all([
        bound,
        id
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    });
    else if (id) bound = Promise.resolve(id).then(function() {
        return requireModule(serverReference);
    });
    else return requireModule(serverReference);
    bound.then(createModelResolver(parentChunk, parentObject, key, !1, response, createModel, []), createModelReject(parentChunk));
    return null;
}
function reviveModel(response, parentObj, parentKey, value, reference) {
    if ("string" === typeof value) return parseModelString(response, parentObj, parentKey, value, reference);
    if ("object" === typeof value && null !== value) {
        if (void 0 !== reference && void 0 !== response._temporaryReferences && response._temporaryReferences.set(value, reference), Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = reviveModel(response, value, "" + i, value[i], void 0 !== reference ? reference + ":" + i : void 0);
        else for(i in value)hasOwnProperty.call(value, i) && (parentObj = void 0 !== reference && -1 === i.indexOf(":") ? reference + ":" + i : void 0, parentObj = reviveModel(response, value, i, value[i], parentObj), void 0 !== parentObj ? value[i] = parentObj : delete value[i]);
    }
    return value;
}
var initializingChunk = null, initializingChunkBlockedModel = null;
function initializeModelChunk(chunk) {
    var prevChunk = initializingChunk, prevBlocked = initializingChunkBlockedModel;
    initializingChunk = chunk;
    initializingChunkBlockedModel = null;
    var rootReference = -1 === chunk.reason ? void 0 : chunk.reason.toString(16), resolvedModel = chunk.value;
    chunk.status = "cyclic";
    chunk.value = null;
    chunk.reason = null;
    try {
        var rawModel = JSON.parse(resolvedModel), value = reviveModel(chunk._response, {
            "": rawModel
        }, "", rawModel, rootReference);
        if (null !== initializingChunkBlockedModel && 0 < initializingChunkBlockedModel.deps) initializingChunkBlockedModel.value = value, chunk.status = "blocked";
        else {
            var resolveListeners = chunk.value;
            chunk.status = "fulfilled";
            chunk.value = value;
            null !== resolveListeners && wakeChunk(resolveListeners, value);
        }
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingChunk = prevChunk, initializingChunkBlockedModel = prevBlocked;
    }
}
function reportGlobalError(response, error) {
    response._closed = !0;
    response._closedReason = error;
    response._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(chunk, error);
    });
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._formData.get(response._prefix + id), chunk = null != chunk ? new Chunk("resolved_model", chunk, id, response) : response._closed ? new Chunk("rejected", null, response._closedReason, response) : createPendingChunk(response), chunks.set(id, chunk));
    return chunk;
}
function createModelResolver(chunk, parentObject, key, cyclic, response, map, path) {
    if (initializingChunkBlockedModel) {
        var blocked = initializingChunkBlockedModel;
        cyclic || blocked.deps++;
    } else blocked = initializingChunkBlockedModel = {
        deps: cyclic ? 0 : 1,
        value: null
    };
    return function(value) {
        for(var i = 1; i < path.length; i++)value = value[path[i]];
        parentObject[key] = map(response, value);
        "" === key && null === blocked.value && (blocked.value = parentObject[key]);
        blocked.deps--;
        0 === blocked.deps && "blocked" === chunk.status && (value = chunk.value, chunk.status = "fulfilled", chunk.value = blocked.value, null !== value && wakeChunk(value, blocked.value));
    };
}
function createModelReject(chunk) {
    return function(error) {
        return triggerErrorOnChunk(chunk, error);
    };
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            parentObject = id.value;
            for(key = 1; key < reference.length; key++)parentObject = parentObject[reference[key]];
            return map(response, parentObject);
        case "pending":
        case "blocked":
        case "cyclic":
            var parentChunk = initializingChunk;
            id.then(createModelResolver(parentChunk, parentObject, key, "cyclic" === id.status, response, map, reference), createModelReject(parentChunk));
            return null;
        default:
            throw id.reason;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseTypedArray(response, reference, constructor, bytesPerElement, parentObject, parentKey) {
    reference = parseInt(reference.slice(2), 16);
    reference = response._formData.get(response._prefix + reference);
    reference = constructor === ArrayBuffer ? reference.arrayBuffer() : reference.arrayBuffer().then(function(buffer) {
        return new constructor(buffer);
    });
    bytesPerElement = initializingChunk;
    reference.then(createModelResolver(bytesPerElement, parentObject, parentKey, !1, response, createModel, []), createModelReject(bytesPerElement));
    return null;
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    stream = new Chunk("fulfilled", stream, controller, response);
    chunks.set(id, stream);
    response = response._formData.getAll(response._prefix + id);
    for(id = 0; id < response.length; id++)chunks = response[id], "C" === chunks[0] ? controller.close("C" === chunks ? '"$undefined"' : chunks.slice(1)) : controller.enqueueModel(chunks);
}
function parseReadableStream(response, reference, type) {
    reference = parseInt(reference.slice(2), 16);
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, reference, type, {
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new Chunk("resolved_model", json, -1, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$26 = createPendingChunk(response);
                chunk$26.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$26;
                chunk.then(function() {
                    previousBlockedChunk === chunk$26 && (previousBlockedChunk = null);
                    resolveModelChunk(chunk$26, json, -1);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
    return type;
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function parseAsyncIterable(response, reference, iterator) {
    reference = parseInt(reference.slice(2), 16);
    var buffer = [], closed = !1, nextWriteIndex = 0, $jscomp$compprop2 = {};
    $jscomp$compprop2 = ($jscomp$compprop2[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new Chunk("fulfilled", {
                    done: !0,
                    value: void 0
                }, null, response);
                buffer[nextReadIndex] = createPendingChunk(response);
            }
            return buffer[nextReadIndex++];
        });
    }, $jscomp$compprop2);
    iterator = iterator ? $jscomp$compprop2[ASYNC_ITERATOR]() : $jscomp$compprop2;
    resolveStream(response, reference, iterator, {
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = createPendingChunk(response)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(buffer[nextWriteIndex++], error);
        }
    });
    return iterator;
}
function parseModelString(response, obj, key, value, reference) {
    if ("$" === value[0]) {
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "@":
                return obj = parseInt(value.slice(2), 16), getChunk(response, obj);
            case "F":
                return value = value.slice(2), value = getOutlinedModel(response, value, obj, key, createModel), loadServerReference$1(response, value.id, value.bound, initializingChunk, obj, key);
            case "T":
                if (void 0 === reference || void 0 === response._temporaryReferences) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
                return createTemporaryReference(response._temporaryReferences, reference);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createSet);
            case "K":
                obj = value.slice(2);
                var formPrefix = response._prefix + obj + "_", data = new FormData();
                response._formData.forEach(function(entry, entryKey) {
                    entryKey.startsWith(formPrefix) && data.append(entryKey.slice(formPrefix.length), entry);
                });
                return data;
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
        }
        switch(value[1]){
            case "A":
                return parseTypedArray(response, value, ArrayBuffer, 1, obj, key);
            case "O":
                return parseTypedArray(response, value, Int8Array, 1, obj, key);
            case "o":
                return parseTypedArray(response, value, Uint8Array, 1, obj, key);
            case "U":
                return parseTypedArray(response, value, Uint8ClampedArray, 1, obj, key);
            case "S":
                return parseTypedArray(response, value, Int16Array, 2, obj, key);
            case "s":
                return parseTypedArray(response, value, Uint16Array, 2, obj, key);
            case "L":
                return parseTypedArray(response, value, Int32Array, 4, obj, key);
            case "l":
                return parseTypedArray(response, value, Uint32Array, 4, obj, key);
            case "G":
                return parseTypedArray(response, value, Float32Array, 4, obj, key);
            case "g":
                return parseTypedArray(response, value, Float64Array, 8, obj, key);
            case "M":
                return parseTypedArray(response, value, BigInt64Array, 8, obj, key);
            case "m":
                return parseTypedArray(response, value, BigUint64Array, 8, obj, key);
            case "V":
                return parseTypedArray(response, value, DataView, 1, obj, key);
            case "B":
                return obj = parseInt(value.slice(2), 16), response._formData.get(response._prefix + obj);
        }
        switch(value[1]){
            case "R":
                return parseReadableStream(response, value, void 0);
            case "r":
                return parseReadableStream(response, value, "bytes");
            case "X":
                return parseAsyncIterable(response, value, !1);
            case "x":
                return parseAsyncIterable(response, value, !0);
        }
        value = value.slice(1);
        return getOutlinedModel(response, value, obj, key, createModel);
    }
    return value;
}
function createResponse(bundlerConfig, formFieldPrefix, temporaryReferences) {
    var backingFormData = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : new FormData(), chunks = new Map();
    return {
        _bundlerConfig: bundlerConfig,
        _prefix: formFieldPrefix,
        _formData: backingFormData,
        _chunks: chunks,
        _closed: !1,
        _closedReason: null,
        _temporaryReferences: temporaryReferences
    };
}
function close(response) {
    reportGlobalError(response, Error("Connection closed."));
}
function loadServerReference(bundlerConfig, id, bound) {
    var serverReference = resolveServerReference(bundlerConfig, id);
    bundlerConfig = preloadModule$1(serverReference);
    return bound ? Promise.all([
        bound,
        bundlerConfig
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    }) : bundlerConfig ? Promise.resolve(bundlerConfig).then(function() {
        return requireModule(serverReference);
    }) : Promise.resolve(requireModule(serverReference));
}
function decodeBoundActionMetaData(body, serverManifest, formFieldPrefix) {
    body = createResponse(serverManifest, formFieldPrefix, void 0, body);
    close(body);
    body = getChunk(body, 0);
    body.then(function() {});
    if ("fulfilled" !== body.status) throw body.reason;
    return body.value;
}
function decodeAction$1(body, serverManifest) {
    var formData = new FormData(), action = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_") ? key.startsWith("$ACTION_REF_") ? (value = "$ACTION_" + key.slice(12) + ":", value = decodeBoundActionMetaData(body, serverManifest, value), action = loadServerReference(serverManifest, value.id, value.bound)) : key.startsWith("$ACTION_ID_") && (value = key.slice(11), action = loadServerReference(serverManifest, value, null)) : formData.append(key, value);
    });
    return null === action ? null : action.then(function(fn) {
        return fn.bind(null, formData);
    });
}
function decodeFormState$1(actionResult, body, serverManifest) {
    var keyPath = body.get("$ACTION_KEY");
    if ("string" !== typeof keyPath) return Promise.resolve(null);
    var metaData = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_REF_") && (value = "$ACTION_" + key.slice(12) + ":", metaData = decodeBoundActionMetaData(body, serverManifest, value));
    });
    if (null === metaData) return Promise.resolve(null);
    var referenceId = metaData.id;
    return Promise.resolve(metaData.bound).then(function(bound) {
        return null === bound ? null : [
            actionResult,
            keyPath,
            referenceId,
            bound.length - 1
        ];
    });
}
var serverManifest = {};
exports.createClientReference = function(id, exportName, bundles, importMap) {
    return {
        $$typeof: CLIENT_REFERENCE_TAG$1,
        $$id: id,
        $$name: exportName,
        $$bundles: bundles,
        $$importMap: importMap
    };
};
exports.createTemporaryReferenceSet = function() {
    return new WeakMap();
};
exports.decodeAction = function(body) {
    return decodeAction$1(body, serverManifest);
};
exports.decodeFormState = function(actionResult, body) {
    return decodeFormState$1(actionResult, body, serverManifest);
};
exports.decodeReply = function(body, options) {
    if ("string" === typeof body) {
        var form = new FormData();
        form.append("0", body);
        body = form;
    }
    body = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0, body);
    options = getChunk(body, 0);
    close(body);
    return options;
};
exports.decodeReplyFromAsyncIterable = function(iterable, options) {
    function progress(entry) {
        if (entry.done) close(response);
        else {
            entry = entry.value;
            var name = entry[0];
            entry = entry[1];
            if ("string" === typeof entry) {
                response._formData.append(name, entry);
                var prefix = response._prefix;
                if (name.startsWith(prefix)) {
                    var chunks = response._chunks;
                    name = +name.slice(prefix.length);
                    (chunks = chunks.get(name)) && resolveModelChunk(chunks, entry, name);
                }
            } else response._formData.append(name, entry);
            iterator.next().then(progress, error);
        }
    }
    function error(reason) {
        reportGlobalError(response, reason);
        "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
    }
    var iterator = iterable[ASYNC_ITERATOR](), response = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0);
    iterator.next().then(progress, error);
    return getChunk(response, 0);
};
exports.loadServerAction = function(id) {
    var reference = resolveServerReference(serverManifest, id);
    return Promise.resolve(reference).then(function() {
        return preloadModule$1(reference);
    }).then(function() {
        var fn = requireModule(reference);
        if ("function" !== typeof fn) throw Error("Server actions must be functions");
        return fn;
    });
};
exports.registerServerActions = function(manifest) {
    serverManifest = manifest;
};
exports.registerServerReference = function(reference, id, exportName) {
    return Object.defineProperties(reference, {
        $$typeof: {
            value: SERVER_REFERENCE_TAG
        },
        $$id: {
            value: id + "#" + exportName,
            configurable: !0
        },
        $$bound: {
            value: null,
            configurable: !0
        },
        bind: {
            value: bind,
            configurable: !0
        }
    });
};
exports.renderToReadableStream = function(model, options) {
    var request = new RequestInstance(20, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, noop, noop, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
    if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
            var listener = function() {
                abort(request, signal.reason);
                signal.removeEventListener("abort", listener);
            };
            signal.addEventListener("abort", listener);
        }
    }
    return new ReadableStream({
        type: "bytes",
        start: function() {
            startWork(request);
        },
        pull: function(controller) {
            startFlowing(request, controller);
        },
        cancel: function(reason) {
            request.destination = null;
            abort(request, reason);
        }
    }, {
        highWaterMark: 0
    });
};
exports.unstable_prerender = function(model, options) {
    return new Promise(function(resolve, reject) {
        var request = new RequestInstance(21, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            resolve({
                prelude: stream
            });
        }, reject, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(request, signal.reason);
            else {
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        startWork(request);
    });
};

},{"2381f0f3ff03ff95":"gC2PC","6db66a729b66b575":"a1TxN"}],"gC2PC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"c4Fud"}],"c4Fud":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.0";

},{"6a05e75e64e4f862":"a1TxN"}],"a1TxN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"4tF2f"}],"4tF2f":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.0";

},{}],"gU4lG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBarContext", ()=>ActionBarContext);
parcelHelpers.export(exports, "ActionBar", ()=>ActionBar);
parcelHelpers.export(exports, "useActionBarContainer", ()=>useActionBarContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonGroup = require("./ActionButtonGroup");
var _liveAnnouncer = require("@react-aria/live-announcer");
var _closeButton = require("./CloseButton");
var _react = require("react");
var _reactAria = require("react-aria");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-stately/utils");
var _utils1 = require("@react-spectrum/utils");
var _utils2 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const actionBarStyles = function anonymous(props) {
    let rules = " ";
    rules += ' oc12';
    rules += ' nc12';
    rules += ' kc12';
    rules += ' jc12';
    if (props.isEmphasized) rules += ' -Ovbhqd-g012';
    else rules += ' -Ovbhqd-g_g12';
    rules += ' gEzkoQe12';
    rules += ' _nLeasBb12';
    rules += ' _oa12';
    rules += ' _Lf12';
    rules += ' _Mb12';
    if (props.isEmphasized) rules += ' Oj12';
    else rules += ' Oye39g12';
    rules += ' Ola12';
    rules += ' St12';
    rules += ' Rt12';
    rules += ' Te12';
    rules += ' Qe12';
    rules += ' sd12';
    rules += ' Ul12';
    rules += ' ql12';
    rules += ' eb12';
    if (props.isInContainer) rules += ' _Pa12';
    rules += ' _lr12';
    rules += ' _AI12';
    rules += ' -F3Iohc-_zI12';
    if (props.isInContainer) rules += ' Zd12';
    else rules += ' Za12';
    rules += ' IM12';
    rules += ' HM12';
    rules += ' Ll12';
    rules += ' Yg12';
    rules += ' Xc12';
    rules += ' _2b12';
    if (props.isExiting) {
        rules += ' -_8PloMd-t12';
        rules += ' __Ya12';
    } else if (props.isEntering) {
        rules += ' -_8PloMd-t12';
        rules += ' __Ya12';
    } else {
        rules += ' -_8PloMd-q12';
        rules += ' __Ya12';
    }
    return rules;
};
const ActionBarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ActionBar = /*#__PURE__*/ (0, _react.forwardRef)(function ActionBar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ActionBarContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isOpen = props.selectedItemCount !== 0;
    let isExiting = (0, _utils2.useExitAnimation)(domRef, isOpen && props.scrollRef != null);
    if (!isOpen && !isExiting) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBarInner, {
        ...props,
        ref: domRef,
        isExiting: isExiting
    });
});
const ActionBarInner = /*#__PURE__*/ (0, _react.forwardRef)(function ActionBarInner(props1, ref) {
    let { isEmphasized, selectedItemCount = 0, children, onClearSelection, isExiting } = props1;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    // Store the last count greater than zero so that we can retain it while rendering the fade-out animation.
    let [lastCount, setLastCount] = (0, _react.useState)(selectedItemCount);
    if ((selectedItemCount === 'all' || selectedItemCount > 0) && selectedItemCount !== lastCount) setLastCount(selectedItemCount);
    // Measure the width of the collection's scrollbar and offset the action bar by that amount.
    let scrollRef = props1.scrollRef;
    let [scrollbarWidth, setScrollbarWidth] = (0, _react.useState)(0);
    let updateScrollbarWidth = (0, _react.useCallback)(()=>{
        let el = scrollRef?.current;
        if (el) {
            let w = el.offsetWidth - el.clientWidth;
            setScrollbarWidth(w);
        }
    }, [
        scrollRef
    ]);
    (0, _utils2.useResizeObserver)({
        ref: scrollRef,
        onResize: updateScrollbarWidth
    });
    let { keyboardProps } = (0, _reactAria.useKeyboard)({
        onKeyDown (e) {
            if (e.key === 'Escape') {
                e.preventDefault();
                onClearSelection?.();
            } else e.continuePropagation();
        }
    });
    // Announce "actions available" on mount.
    let isInitial = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if (isInitial.current && scrollRef) {
            isInitial.current = false;
            (0, _liveAnnouncer.announce)(stringFormatter.format('actionbar.actionsAvailable'));
        }
    }, [
        stringFormatter,
        scrollRef
    ]);
    let objectRef = (0, _utils2.useObjectRef)(ref);
    let isEntering = (0, _utils2.useEnterAnimation)(objectRef, !!scrollRef);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAria.FocusScope), {
        restoreFocus: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            ref: objectRef,
            ...keyboardProps,
            className: actionBarStyles({
                isEmphasized,
                isInContainer: !!scrollRef,
                isEntering,
                isExiting
            }),
            style: {
                insetInlineEnd: `calc(var(--insetEnd) + ${scrollbarWidth}px)`
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " _Jb12 IM12",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButtonGroup.ActionButtonGroup), {
                        staticColor: isEmphasized ? 'auto' : undefined,
                        isQuiet: true,
                        "aria-label": stringFormatter.format('actionbar.actions'),
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " _Ja12 sd12 eb12 Ub12 qb12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                            staticColor: isEmphasized ? 'auto' : undefined,
                            "aria-label": stringFormatter.format('actionbar.clearSelection'),
                            onPress: ()=>onClearSelection?.()
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' uk12';
                                rules += ' uch12';
                                rules += ' udi12';
                                rules += ' uea12';
                                rules += ' ugb12';
                                rules += ' uhd12';
                                rules += ' uje12';
                                rules += ' u2NhKxcl12';
                                rules += ' uic12';
                                rules += ' -_6BNtrc-c12';
                                rules += ' vx12';
                                rules += ' xb12';
                                rules += ' _xa12';
                                rules += ' _Fd12';
                                rules += ' _FezxGHba12';
                                rules += ' _FnuYUweb12';
                                if (props.isEmphasized) rules += ' pr12';
                                else rules += ' pt12';
                                return rules;
                            }({
                                isEmphasized
                            }),
                            children: lastCount === 'all' ? stringFormatter.format('actionbar.selectedAll') : stringFormatter.format('actionbar.selected', {
                                count: lastCount
                            })
                        })
                    ]
                })
            ]
        })
    });
});
function useActionBarContainer(props) {
    let { renderActionBar, scrollRef } = props;
    let [selectedKeys, setSelectedKeys] = (0, _utils.useControlledState)(props.selectedKeys, props.defaultSelectedKeys || new Set(), props.onSelectionChange);
    let selectedKeysSet = (0, _react.useMemo)(()=>selectedKeys === 'all' ? selectedKeys : new Set(selectedKeys), [
        selectedKeys
    ]);
    let actionBar = (0, _react.useMemo)(()=>renderActionBar?.(selectedKeysSet), [
        renderActionBar,
        selectedKeysSet
    ]);
    let selectedItemCount = selectedKeysSet === 'all' ? 'all' : selectedKeysSet.size;
    let [actionBarHeight, setActionBarHeight] = (0, _react.useState)(0);
    let actionBarRef = (0, _react.useCallback)((ref)=>{
        let actionBar = ref?.UNSAFE_getDOMNode();
        if (actionBar) setActionBarHeight(actionBar.offsetHeight + 8);
        else setActionBarHeight(0);
    }, []);
    let actionBarContext = (0, _react.useMemo)(()=>({
            ref: actionBarRef,
            scrollRef,
            selectedItemCount,
            onClearSelection: ()=>setSelectedKeys(new Set())
        }), [
        scrollRef,
        actionBarRef,
        selectedItemCount,
        setSelectedKeys
    ]);
    let wrappedActionBar = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBarContext.Provider, {
            value: actionBarContext,
            children: actionBar
        }), [
        actionBarContext,
        actionBar
    ]);
    return {
        selectedKeys,
        onSelectionChange: setSelectedKeys,
        actionBar: wrappedActionBar,
        actionBarHeight
    };
}

},{"0":"frYaX","1":"jeYGC","2":"bRL5Y","3":"2YRKv","react/jsx-runtime":"2Is6Z","./ActionButtonGroup":"1RyqL","@react-aria/live-announcer":"3nbSW","./CloseButton":"8LP64","react":"a1TxN","react-aria":[["FocusScope","9oPIl"],["useKeyboard","vsbUl"]],"../intl/*.json":"gDH3q","@react-stately/utils":"4Nj6T","@react-spectrum/utils":"jqfrX","@react-aria/utils":[["useEnterAnimation","a1dBG"],["useExitAnimation","a1dBG"],["useObjectRef","laqO5"],["useResizeObserver","7OAb4"]],"@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"frYaX":[function() {},{}],"jeYGC":[function() {},{}],"bRL5Y":[function() {},{}],"2YRKv":[function() {},{}],"h4rDR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.78 1.757C16.51.716 14.555.858 13.33 2.08L3.079 12.334c-.32.32-.559.717-.69 1.15l-1.384 4.584c-.08.265-.007.552.188.747.142.143.334.22.53.22q.11 0 .217-.032l4.582-1.384c.434-.13.832-.368 1.151-.688L18.028 6.575c.648-.647.993-1.545.948-2.46s-.482-1.775-1.195-2.358M2.846 17.163l.98-3.246q.042-.135.113-.257l2.41 2.409q-.123.07-.259.114zM16.966 5.516l-9.525 9.526-2.475-2.476 9.425-9.425c.386-.387.896-.586 1.39-.586.38 0 .752.119 1.05.362.392.321.621.772.646 1.272.025.494-.161.977-.51 1.327"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"elAa6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.249 15.021c-.4 0-.733-.317-.748-.72l-.25-6.5c-.017-.414.307-.763.72-.779H8c.4 0 .733.317.748.72l.25 6.5c.017.414-.307.763-.72.778zM11.751 15.021h-.03c-.413-.016-.737-.365-.72-.779l.25-6.5c.015-.403.348-.72.748-.72h.03c.413.016.737.365.72.779l-.25 6.5c-.015.403-.348.72-.748.72"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17 4h-3.5v-.75C13.5 2.01 12.49 1 11.25 1h-2.5C7.51 1 6.5 2.01 6.5 3.25V4H3c-.414 0-.75.336-.75.75s.336.75.75.75h.52l.422 10.342C3.99 17.052 4.98 18 6.19 18h7.62c1.211 0 2.2-.948 2.248-2.158L16.48 5.5H17c.414 0 .75-.336.75-.75S17.414 4 17 4m-9-.75c0-.413.337-.75.75-.75h2.5c.413 0 .75.337.75.75V4H8zm6.56 12.531c-.017.404-.346.719-.75.719H6.19c-.404 0-.733-.315-.75-.719L5.02 5.5h9.96z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kmqkh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.75 16.465c-.187 0-.374-.07-.52-.21-.298-.287-.308-.762-.02-1.06l4.999-5.197-4.986-5.184c-.288-.297-.279-.772.02-1.06.296-.286.774-.278 1.06.021L13.79 9.48c.28.29.28.749 0 1.039l-5.5 5.716c-.146.154-.344.23-.54.23"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cSREm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.53 17.47-5.083-5.084C14.417 11.186 15 9.66 15 8c0-3.86-3.14-7-7-7S1 4.14 1 8s3.14 7 7 7c1.66 0 3.185-.584 4.386-1.553l5.084 5.083c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M8 13.5c-3.032 0-5.5-2.468-5.5-5.5S4.968 2.5 8 2.5s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2370J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13 2.5H7c-.414 0-.75-.336-.75-.75S6.586 1 7 1h6c.414 0 .75.336.75.75s-.336.75-.75.75M16.773 14.48q-.022-.046-.05-.09L12.49 7.78V5.493h.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.414 0-.75.336-.75.75V8c0 .144.041.284.119.404l1.171 1.83-5.686 1.743 2.279-3.574c.076-.12.117-.26.117-.403V4.743c0-.414-.336-.75-.75-.75H6.99c-.414 0-.75.336-.75.75s.336.75.75.75h.5v2.288l-4.213 6.61q-.028.043-.049.09c-.351.761-.29 1.638.164 2.346C3.86 17.562 4.67 18 5.558 18h8.884c.887 0 1.697-.438 2.167-1.173.453-.708.515-1.585.164-2.347m-1.427 1.539c-.193.301-.531.481-.904.481H5.558c-.373 0-.71-.18-.904-.481-.171-.268-.2-.582-.082-.87l.779-1.222 7.768-2.383 2.31 3.604c.117.29.088.604-.083.87"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1QXwE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.864 15.734c-.222 0-.433-.098-.576-.27l-3.747-4.497c-.266-.319-.222-.792.096-1.057.317-.265.79-.223 1.056.096l3.154 3.786 7.44-9.469c.255-.326.728-.382 1.052-.127.326.256.383.728.127 1.053L8.454 15.447c-.14.179-.352.284-.579.287z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aI18O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m11.06 10 5.207-5.206c.293-.293.293-.768 0-1.06s-.767-.294-1.06 0L10 8.938 4.793 3.733c-.293-.293-.767-.293-1.06 0s-.293.768 0 1.06L8.939 10l-5.206 5.206c-.293.293-.293.768 0 1.06.146.147.338.22.53.22s.384-.073.53-.22L10 11.062l5.207 5.206c.146.146.338.22.53.22s.384-.074.53-.22c.293-.293.293-.768 0-1.06z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ipfe6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.28 13.22c-.293-.293-.767-.293-1.06 0L16 14.44V3.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v10.69l-1.22-1.22c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l2.5 2.5q.105.105.243.162c.138.057.19.058.287.058s.195-.02.287-.058.174-.093.243-.162l2.5-2.5c.293-.293.293-.767 0-1.06M7.25 14.5h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75M9.25 10.5h-6.5c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 6.5h-8.5c-.414 0-.75-.336-.75-.75S2.336 5 2.75 5h8.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9pN2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.28 5.72-2.5-2.5q-.105-.105-.243-.162c-.184-.076-.39-.076-.574 0q-.138.058-.243.162l-2.5 2.5c-.293.293-.293.767 0 1.06s.767.293 1.06 0l1.22-1.22v10.69c0 .414.336.75.75.75s.75-.336.75-.75V5.56l1.22 1.22c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M7.25 6.5h-4.5c-.414 0-.75-.336-.75-.75S2.336 5 2.75 5h4.5c.414 0 .75.336.75.75s-.336.75-.75.75M9.25 10.5h-6.5c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 14.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"deyzk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridSelectionAnnouncement", ()=>useGridSelectionAnnouncement);
var _liveAnnouncer = require("@react-aria/live-announcer");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _i18N = require("@react-aria/i18n");
var _utils = require("@react-aria/utils");
function useGridSelectionAnnouncement(props, state) {
    let { getRowText = (key)=>state.collection.getTextValue?.(key) ?? state.collection.getItem(key)?.textValue } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = (0, _react.useRef)(selection);
    let announceSelectionChange = (0, _react.useCallback)(()=>{
        if (!state.selectionManager.isFocused || selection === lastSelection.current) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = diffSelection(selection, lastSelection.current);
        let removedKeys = diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === 'replace';
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            let firstKey = state.selectionManager.selectedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let currentSelectionText = getRowText(firstKey);
                if (currentSelectionText) messages.push(stringFormatter.format('selectedItem', {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let firstKey = addedKeys.keys().next().value;
            if (firstKey != null) {
                let addedText = getRowText(firstKey);
                if (addedText) messages.push(stringFormatter.format('selectedItem', {
                    item: addedText
                }));
            }
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            let firstKey = removedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let removedText = getRowText(firstKey);
                if (removedText) messages.push(stringFormatter.format('deselectedItem', {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === 'multiple') {
            if (messages.length === 0 || selection === 'all' || selection.size > 1 || lastSelection.current === 'all' || lastSelection.current?.size > 1) messages.push(selection === 'all' ? stringFormatter.format('selectedAll') : stringFormatter.format('selectedCount', {
                count: selection.size
            }));
        }
        if (messages.length > 0) (0, _liveAnnouncer.announce)(messages.join(' '));
        lastSelection.current = selection;
    }, [
        selection,
        state.selectionManager.selectedKeys,
        state.selectionManager.isFocused,
        state.selectionManager.selectionBehavior,
        state.selectionManager.selectionMode,
        state.collection,
        getRowText,
        stringFormatter
    ]);
    // useUpdateEffect will handle using useEffectEvent, no need to stabilize anything on this end
    (0, _utils.useUpdateEffect)(()=>{
        if (state.selectionManager.isFocused) announceSelectionChange();
        else {
            // Wait a frame in case the collection is about to become focused (e.g. on mouse down).
            let raf = requestAnimationFrame(announceSelectionChange);
            return ()=>cancelAnimationFrame(raf);
        }
    }, [
        selection,
        state.selectionManager.isFocused
    ]);
}
function diffSelection(a, b) {
    let res = new Set();
    if (a === 'all' || b === 'all') return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}

},{"@react-aria/live-announcer":"3nbSW","../intl/*.json":"hdtsN","react":"a1TxN","@react-aria/i18n":"7lxyl","@react-aria/utils":"ekc37","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hdtsN":[function(require,module,exports,__globalThis) {
const _temp0 = require("549f76802fea3145");
const _temp1 = require("99e711b09beafbae");
const _temp2 = require("d822d49a9f50f8f2");
const _temp3 = require("62716c14c7ab3b19");
const _temp4 = require("f993c3bd895f4a55");
const _temp5 = require("87ba517e0d2284cb");
const _temp6 = require("9959e6866268baa2");
const _temp7 = require("a5d29cf49321ccbd");
const _temp8 = require("d4a263166a379f7");
const _temp9 = require("adb7cef23c3e7915");
const _temp10 = require("b85e649d4f0c8fa0");
const _temp11 = require("669dff92f11c15b2");
const _temp12 = require("56a3bfdc95a3af99");
const _temp13 = require("92bd2be1c2e45a26");
const _temp14 = require("ac7b779e60091ebf");
const _temp15 = require("7350c7eb30e615e3");
const _temp16 = require("3260bfccae03c79c");
const _temp17 = require("e01abdb08e203859");
const _temp18 = require("5551bd334b751799");
const _temp19 = require("a555cf93e0917ba2");
const _temp20 = require("f519d273a2594a58");
const _temp21 = require("2ab2dc559350f8cb");
const _temp22 = require("aa7f9e578044416a");
const _temp23 = require("7828f13f1de12a9c");
const _temp24 = require("b776cb1c3588783c");
const _temp25 = require("b2c037c8f99b4b1d");
const _temp26 = require("3656d7d096e21208");
const _temp27 = require("64de068ffd5db517");
const _temp28 = require("6afb03c6be24a7db");
const _temp29 = require("fac4d0e10b154d11");
const _temp30 = require("5207f24182fa30c9");
const _temp31 = require("6c177c75c6c9f015");
const _temp32 = require("1c95bec940ff1fe8");
const _temp33 = require("736ec483e330f374");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"549f76802fea3145":"ctpKo","99e711b09beafbae":"ctpKo","d822d49a9f50f8f2":"ctpKo","62716c14c7ab3b19":"ctpKo","f993c3bd895f4a55":"ctpKo","87ba517e0d2284cb":"ctpKo","9959e6866268baa2":"3Tpgz","a5d29cf49321ccbd":"ctpKo","d4a263166a379f7":"ctpKo","adb7cef23c3e7915":"ctpKo","b85e649d4f0c8fa0":"ctpKo","669dff92f11c15b2":"ctpKo","56a3bfdc95a3af99":"ctpKo","92bd2be1c2e45a26":"ctpKo","ac7b779e60091ebf":"ctpKo","7350c7eb30e615e3":"ctpKo","3260bfccae03c79c":"ctpKo","e01abdb08e203859":"ctpKo","5551bd334b751799":"ctpKo","a555cf93e0917ba2":"ctpKo","f519d273a2594a58":"ctpKo","2ab2dc559350f8cb":"ctpKo","aa7f9e578044416a":"ctpKo","7828f13f1de12a9c":"ctpKo","b776cb1c3588783c":"ctpKo","b2c037c8f99b4b1d":"ctpKo","3656d7d096e21208":"ctpKo","64de068ffd5db517":"ctpKo","6afb03c6be24a7db":"ctpKo","fac4d0e10b154d11":"ctpKo","5207f24182fa30c9":"ctpKo","6c177c75c6c9f015":"ctpKo","1c95bec940ff1fe8":"ctpKo","736ec483e330f374":"ctpKo"}],"3Tpgz":[function(require,module,exports,__globalThis) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} not selected.`,
    "select": `Select`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}.`,
    "selectedAll": `All items selected.`,
    "selectedItem": (args)=>`${args.item} selected.`,
    "longPressToSelect": `Long press to enter selection mode.`
};

},{}],"eO4Xt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Computes the description for a grid selectable collection.
 * @param props
 */ parcelHelpers.export(exports, "useHighlightSelectionDescription", ()=>useHighlightSelectionDescription);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _react = require("react");
function useHighlightSelectionDescription(props) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    let modality = (0, _interactions.useInteractionModality)();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === 'pointer' || modality === 'virtual' || modality == null) && typeof window !== 'undefined' && 'ontouchstart' in window;
    let interactionDescription = (0, _react.useMemo)(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message;
        if (shouldLongPress) message = stringFormatter.format('longPressToSelect');
        return selectionBehavior === 'replace' && selectionMode !== 'none' && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        stringFormatter,
        shouldLongPress
    ]);
    let descriptionProps = (0, _utils.useDescription)(interactionDescription);
    return descriptionProps;
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"h4qnk","@react-aria/interactions":"dkfxW","@react-aria/i18n":"7lxyl","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8WxyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid.
 * @param props - Props for the selection checkbox.
 * @param state - State of the grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridSelectionCheckbox", ()=>useGridSelectionCheckbox);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useGridSelectionCheckbox(props, state) {
    let { key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, _utils.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': stringFormatter.format('select'),
            isSelected,
            isDisabled,
            onChange
        }
    };
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"jbI4Y","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {}, "./", "https://reactspectrum.blob.core.windows.net/reactspectrum/aae4f1a83d6ca9684a379b741645ce7e5df981c1/s2-docs/")

//# sourceMappingURL=ActionBar.edfdfea8.js.map
